import { render, staticRenderFns } from "./VentaPadmin.vue?vue&type=template&id=6e5486c8&"
import script from "./VentaPadmin.vue?vue&type=script&lang=js&"
export * from "./VentaPadmin.vue?vue&type=script&lang=js&"
import style0 from "./VentaPadmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports